import { UserAspectAction, UserAspectState } from "./aspect-types";
import { LoadingStateOps } from "../../../domain/data-layer/loading-state";
import { readUserAuthToken } from "./read-user-auth-token";
import isEqual from "react-fast-compare";
import { ANONYMOUS_TOKEN_BROWSER_STORAGE_KEY } from "./state";
import { pushableEventOfPure } from "../../../domain/google-tag-manager/pushable";

export const reducer = (state: UserAspectState, action: UserAspectAction): UserAspectState => {
  switch (action.type) {
    case "user-logged-in": {
      return {
        tag: "logged-in-user",
        authToken: action.value,
        userData: undefined,
        userProfileSf: LoadingStateOps.loadingS,
      };
    }

    case "user-logged-out": {
      return null;
    }

    case "user-ctp-personal-data-loaded": {
      if (!state) {
        return state;
      }

      if (state.tag === "logged-in-user") {
        return isEqual(state.userData, action.value) ? state : { ...state, userData: action.value };
      } else {
        return state;
      }
    }

    case "user-sf-personal-data-loaded": {
      if (!state) {
        return state;
      }

      if (state.tag === "logged-in-user") {
        if (state.userProfileSf.__tag === "loaded" && isEqual(state.userProfileSf.data, action.value)) {
          return state;
        } else {
          void pushableEventOfPure({
            event: "user-data-loaded",
            email: action.value.email,
          }).push();

          return { ...state, userProfileSf: LoadingStateOps.asLoaded(action.value) };
        }
      } else {
        return state;
      }
    }

    case "user-sf-personal-data-failed-to-load": {
      if (!state) {
        return state;
      }

      if (state.tag == "logged-in-user") {
        return { ...state, userProfileSf: LoadingStateOps.asFailed(undefined) };
      } else {
        return state;
      }
    }

    case "token-refreshed": {
      if (!state) {
        return state;
      }

      return { ...state, authToken: action.value };
    }

    case "token-refresh-failed": {
      if (!state) {
        return state;
      }

      return null;
    }

    case "anonymous-token-fetched": {
      if (state?.tag === "anonymous-user" || !state) {
        return { tag: "anonymous-user", authToken: action.value };
      } else {
        return state;
      }
    }

    case "re-initialize": {
      if (!state) {
        return action.value;
      }

      const { value } = action;

      // Not to trigger rerenders...
      if (isEqual(value.tag, state.tag) && isEqual(value.authToken.access_token, state.authToken.access_token)) {
        return state;
      } else {
        return action.value;
      }
    }

    case "token-appears-to-be-invalid": {
      return null;
    }

    case "user-ctp-personal-data-failed-to-load": {
      if (!state || state.tag !== "logged-in-user") {
        return null;
      }

      return {
        ...state,
        userProfileSf: LoadingStateOps.asFailed("error"),
      };
    }

    default: {
      return action;
    }
  }
};
